import { ListItemIcon, ListItemText, Step, StepButton, Stepper } from '@mui/material';
import Stack from '@mui/material/Stack';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { route } from '../route/Index';
import { useAppSelector } from '../store/hook';
import { selectProject } from '../store/project/projectSlice';
import { useTranslation } from 'react-i18next';
import { selectAlert } from '../store/alert/alertSlice';
import { ListItem } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import variable from '../shared/style/variable';
import { EReduxState } from '../store/enum';
import useMediaQuery from '@mui/material/useMediaQuery';
import { theme } from '../style';

interface IStepperProps {}

const StepperRoot = styled(Stepper)`
    width: 50%;
    height: 100%;
`;

const RootStepper = (props: IStepperProps) => {
    const navigate = useNavigate();

    const matches = useMediaQuery(`(min-width:${theme.breakpoints.values.sm}px)`);

    const { t } = useTranslation();

    const project = useAppSelector(selectProject);
    const alert = useAppSelector(selectAlert);
    let projectId = project.data?.project?.id;

    const handleActiveStep = () => {
        let pathname = window.location.pathname;
        if (pathname.endsWith('/')) {
            pathname = pathname.slice(0, -1);
        }
        switch (pathname) {
            case route.info:
                return 0;
            case route.geometry:
                return 1;
            case route.scenario:
                return 2;
            case projectId && route.design.replace(':projectId', projectId.toString()):
                return 3;
            default:
                return 4;
                break;
        }
    };

    let step = handleActiveStep();

    const handleNavigateDesign = () => {
        if (projectId !== undefined) {
            navigate(route.design.replace(':projectId', projectId.toString()));
        }
    };

    const isDisabledGeometry = () => !project.data?.project?.title;

    const isDisabledScenario = () => !(project.data?.project?.geometryId || project.data?.geometry);

    return (
        <Stack direction={'row'} justifyContent={'space-between'}>
            {step !== 4 && (
                <Stack height={'2.5rem'} variant='stepper' width={'40%'}>
                    <StepperRoot nonLinear activeStep={step}>
                        <Step>
                            <StepButton color='inherit' onClick={() => navigate(route.info)}>
                                {matches ? t('projectInfo') : ' - '}
                            </StepButton>
                        </Step>
                        <Step>
                            <StepButton color='inherit' disabled={isDisabledGeometry()} onClick={() => navigate(route.geometry)}>
                                {matches ? t('geometry') : ' - '}
                            </StepButton>
                        </Step>
                        <Step>
                            <StepButton color='inherit' disabled={isDisabledScenario()} onClick={() => navigate(route.scenario)}>
                                {matches ? t('scenario') : ' - '}
                            </StepButton>
                        </Step>
                        <Step>
                            <StepButton color='inherit' onClick={handleNavigateDesign}>
                                {matches && t('designCondition')}
                            </StepButton>
                        </Step>
                    </StepperRoot>
                </Stack>
            )}
            {alert.status == EReduxState.fulfilled && (
                <Stack height={'2.5rem'} variant='alert'>
                    <ListItem style={{ height: '100%' }}>
                        <ListItemIcon>
                            <WarningAmberIcon style={{ fill: variable.white }} />
                        </ListItemIcon>
                        <ListItemText sx={{ display: { xs: 'none', lg: 'block' } }} primary={alert.data!.title} />
                    </ListItem>
                </Stack>
            )}
        </Stack>
    );
};

export default RootStepper;
